import React from 'react'
import Image from "next/image";
import styles from "./tnpsc-admissions.module.css";
import NewBanner from "../../assets/images/home/Banner/TNPSC-GSPCM-July-2026.jpg";
import Banner from "../../assets/images/Tnpsc/TNPSC-RESULT-Web-Banner-2025.jpg";
//import Banner1 from "../../assets/images/Tnpsc/TNPSC-GR-I-II-Prelims-webbanner.jpg";
//import Banner2 from "../../assets/images/Tnpsc/TNPSC-location-Web-banner.jpg";
import NewMob from "../../assets/images/home/Mob_Banner/TNPSC-Gr-I-Mobile-July-Banner.jpg";
import mbBanner from "../../assets/images/Tnpsc/TNPSC-RESULT-Mobile-Banner-2025.jpg";
//import mbBanner1 from "../../assets/images/Tnpsc/TNPSC-GR-I-II-Prelims-Mobile-banner.jpg";
// import mbBanner2 from "../../assets/images/Tnpsc/TNPSC-location-Mobile-banner.jpg";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Interest from '../../components/might-be-interest';
import Pattern from '../tnpsc/pre-pattern';
import dynamic from 'next/dynamic';
import Carousel from 'react-bootstrap/Carousel';
const BranchAddressTNPSC = dynamic(()=>import("../../components/branch-addressTNPSC"));
const Syllabus = dynamic(()=>import( '../tnpsc/pre-syllabus'));
const Exam = dynamic(()=>import( "../tnpsc/pre-exam"));
const TNPSC_form = dynamic(()=>import( "../../components/Forms/tnpsc-admissions-forms"));
const TNPSC_test = dynamic(()=>import( "./test-series"));
import TNPSC_course from "./course-detials";
import TNPSC_prelims from "./prelims";
import Link from "next/link";
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";
const About_TNPSC = () => {

  const banners = [
    { img: Banner, alt: "carousel", link: "/tnpsc-admissions" },
    { img: NewBanner, alt: "carousel", link: "/tnpsc-admissions" },
    
    //{ img: Banner2, alt: "carousel", link:"/tnpsc-admissions" },
    //{ img: Banner1, alt: "carousel", link: "/tnpsc-admissions" },  
  ]

  const mbbanners = [
      { img: mbBanner, alt: "carousel", link: "/tnpsc-admissions" },
    { img: NewMob, alt: "carousel", link: "/tnpsc-admissions" },
  
    // { img: mbBanner2, alt: "carousel", link:"/tnpsc-admissions" },
   // { img: mbBanner1, alt: "carousel", link: "/tnpsc-admissions" },  
  ]

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "TNPSC Coaching Centre in Chennai | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/tnpsc-admissions/",
    "Image":
    "https://www.shankariasacademy.com/_next/static/media/TNPSC%20%20GR%20I%20&%20II%20Prelims%20-%20Web%20banner-01%20(1).3ca275c1.jpg",
    "description": "Choose excellence with Shankar IAS Academy, the top TNPSC Coaching Centre in Chennai. Expert faculty, proven success. Enroll for a bright future!"
  }
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Navigated to ${url}`);
      router.reload(); // Refresh the page on route change
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    // Cleanup on component unmount
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);
  return (
    <>

        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Coaching Centre in Chennai | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Coaching Centre in Chennai | Shankar IAS Academy" />
            <meta name="description" content="Choose excellence with Shankar IAS Academy, the top TNPSC Coaching Centre in Chennai. Expert faculty, proven success. Enroll for a bright future!" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-admissions/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Coaching Centre in Chennai | Shankar IAS Academy" />
            <meta property="og:description" content="Choose excellence with Shankar IAS Academy, the top TNPSC Coaching Centre in Chennai. Expert faculty, proven success. Enroll for a bright future!" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-admissions/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
            <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
        </Head>
        
      <Navbar title="tnpsc" />  

      
      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-4">
            <div
              className={`${styles.tabscrollclass} nav nav-pills align-items-baseline`}
            >
              <Link href='/tnpsc-admissions'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4 active"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-1"
                  type="button"
                  role="tab"
                  aria-controls="centre-1"
                  aria-selected="true"
                >
                  Anna Nagar
                </button>
              </Link>

              <Link href='/tnpsc-adyar'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-2"
                  type="button"
                  role="tab"
                  aria-controls="centre-2"
                  aria-selected="false"
                >
                  Adyar
                </button>
              </Link>

              <Link href='/tnpsc-trichy'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-3"
                  type="button"
                  role="tab"
                  aria-controls="centre-3"
                  aria-selected="false"
                >
                  Trichy
                </button>
              </Link>

              <Link href='/tnpsc-salem'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-4"
                  type="button"
                  role="tab"
                  aria-controls="centre-4"
                  aria-selected="false"
                >
                  Salem
                </button>
              </Link>

              <Link href='/tnpsc-coimbatore'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-5"
                  type="button"
                  role="tab"
                  aria-controls="centre-5"
                  aria-selected="false"
                >
                  Coimbatore
                </button>
              </Link>

              <Link href='/tnpsc-madurai'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-6"
                  type="button"
                  role="tab"
                  aria-controls="centre-6"
                  aria-selected="false"
                >
                  Madurai
                </button>
              </Link>

              <Link href='/tnpsc-namakkal'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-7"
                  type="button"
                  role="tab"
                  aria-controls="centre-7"
                  aria-selected="false"
                >
                  Namakkal
                </button>
              </Link>

              <Link href='/tnpsc-thiruvarur'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-8"
                  type="button"
                  role="tab"
                  aria-controls="centre-8"
                  aria-selected="false"
                >
                  Thiruvarur
                </button>
              </Link>

            </div>
          </div>
        </div>
     

      <div className="container">
          <h1 className={`${styles.pagemaintitle}`}>Admission TNPSC</h1>
      </div>
  
      
      </div>

      {/* large screens */}
      
      <div className="container pb-2">
        <div className="row">
          <div className="col d-none d-md-block">
            <Carousel>
              {banners.map((e, index) =>
                <Carousel.Item key={index}>
                  <Link href={e.link} rel="noreferrer">
                    <Image
                      className="carouselimage w-100 h-100"
                      src={e.img}
                      alt={e.alt}
                      title="Shankar IAS Academy"
                      loading="eager"
                      placeholder="blur"
                    /></Link>
                </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      
      
      {/* small screens */}
      <div className="container pb-2">
      <div className="row">
          <div className="col d-block d-md-none">
            <Carousel>
              {mbbanners.map((e, index) =>
                <Carousel.Item key={index}>
                  <Link href={e.link} rel="noreferrer">
                    <Image
                      className="carouselimage"
                      src={e.img}
                      alt={e.alt}
                      title="Shankar IAS Academy"
                      placeholder="blur"
                    /></Link>
                </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      </div>
      </div>

      <div className="container pt-3">
        <div className="row">
          <div className="col">
            <div
              className={`${styles.tabscrollclass} nav nav-pills mb-3 align-items-baseline justify-content-lg-center`}
            >
              <Link href='#coursedetails'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4 active"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-1"
                  type="button"
                  role="tab"
                  aria-controls="centre-1"
                  aria-selected="true"
                >
                  Course Details
                </button>
              </Link>

              <Link href='/tnpsc-group-i-mains-test-series'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-2"
                  type="button"
                  role="tab"
                  aria-controls="centre-2"
                  aria-selected="false"
                >
                  Test Series
                </button>
              </Link>

              <Link href='#topperlist'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-3"
                  type="button"
                  role="tab"
                  aria-controls="centre-3"
                  aria-selected="false"
                >
                 Topper List
                </button>
              </Link>

              <Link href='#examcriteria'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-4"
                  type="button"
                  role="tab"
                  aria-controls="centre-4"
                  aria-selected="false"
                >
                  Exam Criteria
                </button>
              </Link>

              <Link href='#tnpsccentres'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-5"
                  type="button"
                  role="tab"
                  aria-controls="centre-5"
                  aria-selected="false"
                >
                 Our Centres 
                </button>
              </Link>

              <Link href='/tnpsc-demo-class-video'>
                <button
                  id={styles.tablinks1}
                  className="nav-link py-1 px-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-6"
                  type="button"
                  role="tab"
                  aria-controls="centre-6"
                  aria-selected="false"
                >
                  TNPSC Demo Classes
                </button>
              </Link>


            </div>
          </div>
        </div>
      </div>


     {/*<TNPSC_form /> */}

<div className="container">
  <div className={`${styles.coursesimg} mb-2`}>
    <div class="col-12 col-md-6 offset-md-3 mt-4">
        <p className={`${styles.contactheader} text-center`}>Enquiry</p>
        <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
        <div class={`${styles.addmissionform} npf_wgts mt-2`} data-height="550px" data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
    </div>
  </div>
</div>
      <TNPSC_course />
      <TNPSC_test />
      <TNPSC_prelims />

      <div className='container'>
        <div className='row pt-3'>
          <div className='col'>
            <Pattern />
          </div>
        </div>
      </div>
      <div className='container' id="syllabus">
        <div className='row pt-4'>
          <div className='col'>
            <Syllabus />
          </div>
        </div>
      </div>
      <div className='container-fluid' style={{ backgroundColor: "#F4F6F8" }}>
        <div className='row pt-4'>
          <div className='col'>
            <Exam />
          </div>
        </div>

      </div>

      <BranchAddressTNPSC />
      <Interest />
      <Footer />
    </>
  )
}

export default About_TNPSC;